/*
 * @Author: your name
 * @Date: 2019-06-16 10:04:39
 * @LastEditTime: 2020-11-21 18:07:14
 * @LastEditors: wutt
 * @Description: In User Settings Edit
 * @FilePath: /DianZiDiTu/src/config/AxiosConfigJs.js
 */
import axios from 'axios';

import { ServiceUrlConfig } from './ServiceUrlConfigJs.js';

// import urlConfig from './ServiceUrlConfigJs.js'





let AxiosConfig={

  nationalTDTConfig:null,

  platform:null,

  userManagerSystem:null,

  
  config(timeout)
  { 
    if (!timeout) {
      timeout = 60000;
    }
    
    let tdt_service_base_url=ServiceUrlConfig.tdt_service_base_url;
    
    AxiosConfig.nationalTDTConfig=axios.create({
      baseURL: tdt_service_base_url,
      timeout: timeout
      
    });

    let platform_base_url = ServiceUrlConfig.platform_base_url;
    AxiosConfig.platform = axios.create({
      baseURL: platform_base_url,
      withCredentials:true,
      timeout: timeout,
    });
    let user_mgr_sys_base_url=ServiceUrlConfig.userManagerSytem_base_url_government;

    AxiosConfig.userManagerSystem=axios.create(
      { 
        
        baseURL: user_mgr_sys_base_url,
      timeout: timeout,


      }
    );
    
  }
  

      // nationalTDTConfig:axios.create({
      //   timeout:12000
      // })
      
}

export default AxiosConfig;
